import styled from '@emotion/styled';
import Media from '@ep/components/Media';
import theme from '@ep/theme';
import { Gcms_Asset } from '@ep/types/gatsbyTypes';
import React from 'react';

export interface RelatedProductProps {
  name: string;
  link: string;
  image: Gcms_Asset;
}

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  @media (max-width: ${theme.breakpoints.optimalTablet - 1}px) {
    margin-top: 2rem;
  }
  @media (max-width: ${theme.breakpoints.desktop + 575}px) {
    margin-left: 0rem;
  }
  @media (max-width: ${theme.breakpoints.desktop + 130}px) {
    margin-left: 0rem;
  }
`;

const StyledMedia = styled(Media)`
  margin: 0 auto 2.5rem;
  max-height: 3.5rem;
  margin-bottom: 5rem;
  ${theme.mediaQueries.tablet} {
    margin: 1rem;
  }
  ${theme.mediaQueries.mobile} {
    max-height: 3rem;
    margin: 1rem;
  }
`;

// const handleProductClick = (link: string) => {
//   dataLayer.push({
//     event: 'Page Interaction – user clicked on related product - ' + link,
//   });
// };

function RelatedProduct({ name, link, image }: RelatedProductProps) {
  return (
    <Wrapper>
      <a
        href={link}
        title={name}
        // onClick={() => {
        //   handleProductClick(link);
        // }}
      >
        <StyledMedia media={image} aspectRatio={1} />
      </a>
    </Wrapper>
  );
}

export default RelatedProduct;
